import { render, staticRenderFns } from "./collec.vue?vue&type=template&id=a33cd468&scoped=true"
import script from "./collec.vue?vue&type=script&lang=js"
export * from "./collec.vue?vue&type=script&lang=js"
import style0 from "./collec.vue?vue&type=style&index=0&id=a33cd468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33cd468",
  null
  
)

export default component.exports